import React from 'react'
import { assets } from '../assets/assets'
import { Link } from 'react-router-dom'

const RandomProduct = () => {
  return (
    <div>
       <div className="banner_carousel">
        <div id="carouselExampleIndicators" className="carousel slide">
            <div className="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active"
                    aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                    aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
                    aria-label="Slide 3"></button>
            </div>
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img src={assets.single_img2} className="d-block w-100" alt="Banner Title"/>
                </div>
                <div className="carousel-item">
                    <img src={assets.single_img2} className="d-block w-100" alt="Banner Title"/>
                </div>
                <div className="carousel-item">
                    <img src={assets.single_img2} className="d-block w-100" alt="Banner Title"/>
                </div>
            </div>
        </div>
    </div>

    <div className="product_section mt-4 mt-sm-0 pt-8">
      <div className="container">
        <div className="row">
          {/* Product List Section */}
          <div className="col-lg-5">
            <div className="shop_item">
              {Array(4).fill().map((_, index) => (
                <div key={index} className="product_list text-center text-lg-start mb-4">
                  <h3 className="name mb-4">
                    Celebrate your Birthday with the kids and make your celebration more joyous
                  </h3>
                  <div className="image text-center d-lg-flex align-items-center justify-content-between">
                    <div className="order-md-2 text-md-start">
                      <h4 className="mb-5">Lorem Ipsum is simply dummy (20 kids)</h4>
                    </div>
                    <div className="order-md-1">
                      <img
                        src={assets.cake_img}
                        className="img-fluid mb-2"
                        alt="Lorem Ipsum is simply dummy (20 kids)"
                      />
                    </div>
                  </div>
                  <div className="content d-flex align-items-center justify-content-between">
                    <div className="price">₹600/ Unit</div>
                    <Link to='' className="btn btn-primary text-uppercase">
                      <i className="fa fa-plus"></i> Add
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Sidebar Section */}
          <div className="col-lg-7 sidebar_bg">
            <div className="right_sidebar pb-4">
              {/* Donation Info */}
              <div className="donate_info mb-5">
                <h4>Lorem Ipsum is simply dummy text of</h4>
                <p className="mb-5">Lorem Ipsum is simply dummy text of the printing</p>
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div className="price m-2 m-xl-0">₹500</div>
                  <div className="price m-2 m-xl-0">₹1000</div>
                  <div className="price m-2 m-xl-0">₹2000</div>
                </div>
                <div className="mb-4">
                  <input type="text" name="" className="form-control w-100" />
                  <small>Lorem Ipsum is simply dummy text of the printing</small>
                </div>
                <div className="payment_methods mb-5 d-xl-flex text-center align-items-center">
                  {[1, 2, 3, 4].map((num) => (
                    <img
                      key={num}
                      src={`assets/images/payment/${num}.png`}
                      className="img-fluid mb-3 m-md-1"
                      alt="payment"
                    />
                  ))}
                </div>
                <div className="text-center">
                  <Link to='' className="btn btn-primary text-uppercase w-75 py-3 rounded-2 shadow-none">
                    Donate
                  </Link>
                </div>
              </div>

              {/* Video Section */}
              <div className="video mb-4 position-relative">
                <div className="ratio ratio-16x9">
                  <iframe
                    className="w-100 rounded-4"
                    src="https://www.youtube.com/embed/hAP2QF--2Dg?si=sF8xL9HMWj1MuIgg"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>

              {/* Description Section */}
              <div className="desc">
                <p className="mb-5">
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen book. It has{' '}
                  <span className="text-primary">survived not only five centuries,</span> but also the leap into
                  electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the
                  release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing
                  software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it?
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
                  scrambled it to make a type specimen book. It has{' '}
                  <span className="text-primary">survived not only five centuries,</span> but also the leap into
                  electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the
                  release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing
                  software like Aldus PageMaker including versions of Lorem Ipsum. Why do we use it?
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
  )
}

export default RandomProduct
